import { SubscriptionStatus, type Subscription } from "@prisma/client";

/**
 * Paid access follows live billing status. `canceledAt` in the past is a
 * safety net for two-phase cancel when `status` was never flipped to canceled.
 * Scheduled cancel (`canceledAt` in the future) still grants access.
 */
export const hasEntitledSubscriptionStatus = (
  subscription: Pick<Subscription, "status" | "canceledAt"> | null | undefined,
  now = new Date()
): boolean => {
  if (!subscription) {
    return false;
  }

  const isLiveStatus =
    subscription.status === SubscriptionStatus.active ||
    subscription.status === SubscriptionStatus.trialing;

  if (!isLiveStatus) {
    return false;
  }

  if (!subscription.canceledAt) {
    return true;
  }

  return new Date(subscription.canceledAt).getTime() > now.getTime();
};
